import type { FaireProductEntity } from "../../entity_types/product";

export const p_ezcc9zaydx: FaireProductEntity = {
  token: "p_ezcc9zaydx",
  type: "product",
  name: "I ❤️ Hot Dogs Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/907afb5566e2702ac474566693af6c0d19df7fb0635d3b9f35d94f2d62f9412e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/efcb0da5d2abd4167811d608e855e6bb9f9d3eddbdb143fa5bca0ee194fa806b.jpeg",
    "https://cdn.faire.com/fastly/727ff0ecb994f6408e358cb05c8ee4929748c01a76fb2335f4229c243340a06f.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/eaa327a9e3ade75d6ca76674f3e5b53d8a688cf7ac2f3b8efcbc679f16c55f41.jpeg",
    "https://cdn.faire.com/fastly/e3d29b921f05e0b54dc29f0348b70376aa3cf870f7ad50ec9d69fa89b1a6ca5b.jpeg"
  ],
  priceDollars: 6.75,
  description: "Be frank about your love for weenies, dogs, glizzies—whatever you choose to call them—in these all-American socks.\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance.\n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products—be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:28:11.579Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
